import { BatchTableState } from './batch-table.state';
import { Action, createReducer, on } from '@ngrx/store';
import {
    batchTableChangePage,
    batchTableChangeQuery,
    batchTableFailure, batchTableMasterToggle,
    batchTableRequest, batchTableSetSelection, batchTableSort,
    batchTableSuccess, batchTableToggle
} from './batch-table.actions';

const initialState: BatchTableState = {
    query: {
        sortColumn: 'date',
        sortDescending: true,
        dateAfter: null,
        dateBefore: null,
        pageNumber: 1,
        itemsPerPage: 25,
        name: null
    },
    page: [],
    totalCount: null,
    filteredCount: null,
    busy: false,
    error: false,
    selection: []
};

const reducer = createReducer(
    initialState,
    on(batchTableRequest, (state) => ({
        ...state,
        busy: true,
        error: false
    })),
    on(batchTableSuccess, (state, { totalCount, page }) => ({
        ...state,
        busy: false,
        page,
        totalCount,
        error: false
    })),
    on(batchTableFailure, (state) => ({
        ...state,
        busy: false,
        error: true
    })),
    on(batchTableChangePage, (state, { pageNumber, itemsPerPage }) => ({
        ...state,
        selection: [],
        query: { ...state.query, pageNumber, itemsPerPage }
    })),
    on(batchTableChangeQuery, (state, { query }) => ({
        ...state,
        query
    })),
    on(batchTableSort, (state, { id, descending }) => ({
        ...state,
        query: { ...state.query, sortColumn: id, sortDescending: descending }
    })),
    on(batchTableSetSelection, (state, { selection }) => ({
        ...state,
        selection
    })),
    on(batchTableToggle, (state, { id }) => ({
        ...state,
        selection: state.selection.indexOf(id) === -1 ? [ ...state.selection, id ] : state.selection.filter((sid) => sid !== id)
    })),
    on(batchTableMasterToggle, (state) => ({
        ...state,
        selection: state.selection.length === 0 ? state.page.map(h => h.id) : []
    }))
);

export function batchTableReducer(state: BatchTableState | undefined, action: Action): any {
    return reducer(state, action);
}
